export default "/images/vendor/flag-icons/flags/1x1/gb-nir.svg?319eb77d82e9b5bb406c75143d9ae3a8";